module.exports = {"420802001":"龙泉街道","420802002":"泉口街道","420802100":"栗溪镇","420802101":"子陵铺镇","420802102":"漳河镇","420802103":"马河镇","420802104":"石桥驿镇","420802105":"牌楼镇","420802200":"仙居乡","420802400":"东宝工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420802.json
// module id = 1873
// module chunks = 0